import type { JSX } from 'react';
import { hexWithAlpha } from '../../../_theme/palette.js';
import type { Attachment, FeedbackPalette } from '../types.js';

interface AttachmentListProps {
  palette: FeedbackPalette;
  attachments: Attachment[];
  onRemove: (index: number) => void;
}

export function AttachmentList({ palette, attachments, onRemove }: AttachmentListProps): JSX.Element | null {
  if (attachments.length === 0) return null;
  return (
    <ul
      style={{
        listStyle: 'none',
        padding: 0,
        margin: '12px 0 0',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
      }}
    >
      {attachments.map((attachment, index) => (
        <li
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: hexWithAlpha(palette.primary, 0.08),
            borderRadius: 8,
            padding: '8px 12px',
            fontSize: 13,
            color: palette.text,
          }}
        >
          <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <span style={{ fontSize: 14 }}>{iconForKind(attachment.kind)}</span>
            <span>{attachment.filename ?? `${attachment.kind}-${index + 1}`}</span>
          </span>
          <button
            type="button"
            onClick={() => onRemove(index)}
            aria-label="Remove"
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: palette.textMuted,
              fontSize: 18,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </li>
      ))}
    </ul>
  );
}

function iconForKind(kind: Attachment['kind']): string {
  if (kind === 'screenshot') return '📷';
  if (kind === 'recording') return '🎥';
  return '📎';
}
